import { createSelector } from 'reselect'
import { State } from 'index'

const stockSelector = (state: State) => state.stock

export const getStocks = createSelector([stockSelector], (state) => state.stocks)
